module.exports = __webpack_public_path__ + "img/markerDenuncia.052e174b.png";